<app-navbar title="Leady transportowe">
	<a routerLink="./add" class="btn btn-danger"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-dynamic-table
	module="transport-leads"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
